/* Svensk katalog for locale-payroll-runs-no.js (del 1 av 2).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('sv', {
  'pay.overview': 'Löneöversikt',
  'pay.overviewSub': 'Registrerad lön för räkenskapsåret, grupperad per anställd.',
  'pay.noPayBasis': 'Inget löneunderlag än',
  'pay.noPayBasisHint': 'När lönekörningar har godkänts eller betalats ut visas översikten här.',
  'pay.noPeriodsHint': 'Arbetsgivaravgift och skatteavdrag visas när du har godkända lönekörningar.',
  'pay.noOtpBasisHint': 'Pensionsunderlag visas när du har lönekörningar med pensionsbelopp.',
  'pay.noHolidayPayHint': 'Underlag för semesterersättning visas när du har godkända lönekörningar under vald period.',
  'pay.noPayslipsHint': 'Lönebesked visas när löneutbetalningen har anställda.',
  'pay.noInboxVouchersHint': 'Verifikationer som inte har bokförts än visas här.',
  'pay.noEntriesHint': 'Bokföringsverifikationer visas efter att löneutbetalningen har godkänts.',
  'pay.noFixedLinesHint': 'Lägg in fasta lönerader på anställda för att använda dem i lönekörning.',
  'pay.salaryTypeSearchHintFull': 'Vanliga typer visas först. Sök eller välj Visa fler för hela den aktiva katalogen.',
  'pay.overrideReasonSavedOnLineHint': 'Sparas på löneraden som revisionsspår.',
  'pay.salaryTypeSearchHintRest': 'Vanliga typer visas först. Sök eller välj Visa fler för resten.',
  'pay.overrideReasonSavedOnFixedLineHint': 'Sparas på den fasta raden.',
  'pay.payPeriodMonthOnlyHint': 'Lönekörningar stöder tills vidare bara månadsperioder.',
  'pay.calculationCodeOtherHint': 'Andra beräkningskoder blir tillgängliga när de har implementerats och kontrollerats.',
  'pay.runsAndEmployeesInline': '{{runs}} lönekörn. · {{employees}} anställda',
  'pay.fteShort': 'Årsverken:',
  'pay.taxShort': 'Skatt:',
  'pay.netShort': 'Netto:',
  'pay.holidayPayShort': 'Sem.ers.:',
  'pay.agaShort': 'AGA:',
  'pay.withholdingHelp': 'Skatteavdrag — skatten som dras från bruttolönen och betalas till staten för den anställdas räkning.',
  'pay.holidayPayHelp': 'Intjänad semesterersättning — vanligtvis 10,2 % av löneunderlaget. Betalas ut året efter att den har tjänats in.',
  'pay.aga': 'AGA',
  'pay.agaHelp': 'Arbetsgivaravgift på lönen — avgift som arbetsgivaren betalar till staten utöver lönekostnaden.',
  'pay.fpShort': 'SE:',
  'pay.agaOfHolidayPay': 'AGA på sem.ers.',
  'pay.agaOfHolidayPayHelp': 'Arbetsgivaravgift beräknad på den intjänade semesterersättningen. Reserveras när semesterersättningen tjänas in.',
  'pay.fte': 'Årsverken',
  'pay.fteHelp': 'Tjänstgöringsgrad omräknad till hela årsverken. 1,00 = heltid, 0,50 = halvtid.',
  'pay.overviewFilteredSub': 'Registrerad lön för räkenskapsåret, filtrerad på utbetalningsdatum.',
  'pay.grouping': 'Gruppering',
  'pay.perEmployee': 'Per anställd',
  'pay.perSalaryType': 'Per lönetyp',
  'pay.employeeAndType': 'Anställd och lönetyp',
  'pay.againstWithholding': 'Mot skatteavdrag',
  'pay.againstAga': 'Mot AGA',
  'pay.postedAs': 'Bokförs så här:',
  'pay.postedWithholdingOnly': '{{tax}} mot 2600 skatteavdrag. Öppet före betalning: {{openTax}}.',
  'pay.postedAgaOnly': '{{aga}} mot 2770 arbetsgivaravgift. Öppet före betalning: {{openAga}}.',
  'pay.postedBoth': '{{tax}} mot 2600 skatteavdrag och {{aga}} mot 2770 arbetsgivaravgift. Öppet före betalning: {{openTax}} skatt och {{openAga}} AGA.',
  'pay.autoPostedAgainstWithholding': 'Betalningen konteras automatiskt mot 2600 skatteavdrag och krediterar valt avräkningskonto.',
  'pay.autoPostedAgainstAga': 'Betalningen konteras automatiskt mot 2770 arbetsgivaravgift och krediterar valt avräkningskonto.',
  'pay.autoPostedAgainstBoth': 'Betalningen konteras automatiskt mot 2600 skatteavdrag och 2770 arbetsgivaravgift och krediterar valt avräkningskonto.',
  'pay.agreedAnnualSalary': 'Avtalad årslön',
  'pay.agreedHourlyPay': 'Avtalad timlön',
  'pay.withholdingSeparatePaymentNote': 'Skatteavdrag för lön som betalas ut från 2026 betalas separat senast första bankdagen efter löneutbetalningen.',
  'pay.recommendedForOtpPayment': 'Rekommenderas för OTP-betalning',
  'pay.otpPaymentPostingNote': 'Betalningen bokförs mot valt avräkningskonto och används av översikten Pension/OTP. Bankraden kan sedan matchas mot betalningsverifikationen.',
  'pay.holidayPayAccruedLastYear': 'Semesterersättning, intjänad i fjol',
  'pay.holidayPayAccruedThisYear': 'Semesterersättning, intjänad i år',
  'pay.ordinaryEmployment': 'Ordinär anställning',
  'pay.payslipUncheckAllNote': 'Avmarkera alla anställda om lönebeskeden ska skickas senare. De kan skickas från lönekörningen efter att bokföringen har godkänts.',
  'pay.payslipPdfNotConnected': 'PDF för lönebesked är inte kopplad till backend.',
  'pay.noSalaryLines': 'Inga lönerader',
  'pay.deletedOn': 'Borttagen {{date}}',
  'pay.payrollPaymentOn': 'Löneutbetalning {{date}}',
  'pay.readyLinesForPayroll': '{{count}} godkända rader klara för lön ({{amount}}).',
  'pay.noReadyLinesForPayroll': 'Inga godkända rader klara för lön.',
  'pay.overrideAppliesFutureRuns': 'Åsidosättningen gäller framtida lönekörningar som använder denna fasta rad.',
  'pay.sentToLabel': 'skickas till',
  'pay.recommendedForPayrollPayment': 'Rekommenderas för löneutbetalning',
  'pay.optionalNotePh': 'Valfri anteckning ...',
  'pay.openWithholding': 'Öppet skatteavdrag',
  'pay.openAga': 'Öppen arbetsgivaravgift',
  'pay.noPeriodPayments': 'Inga betalningar registrerade för perioden än.',
  'pay.advance': 'Förskott',
  'pay.agaAndWithholding': 'Arbetsgivaravgift och skatteavdrag',
  'pay.agaAndWithholdingSub': 'Följ upp skatteavdrag och arbetsgivaravgift från godkända lönekörningar per period.',
  'pay.withholdingLongHelp': 'Skatten du har dragit från de anställdas lön. Den hålls kvar på skatteavdragskontot och betalas vidare till staten — den är inte din att använda.',
  'pay.agaLongHelp': 'Avgift som arbetsgivaren betalar till staten på lön och förmåner. Satsen beror på vilken zon (kommun) verksamheten ligger i — 14,1 % i zon 1.',
  'pay.toAuthority': 'Till Skatteetaten',
  'pay.toAuthorityHelp': 'Skatteavdrag plus arbetsgivaravgift — totalbeloppet som ska betalas till staten för perioden.',
  'pay.noPeriods': 'Inga perioder än',
  'pay.period2': 'Period',
  'pay.payrollRunShort': 'Lönekörn.',
  'pay.pensionOtp': 'Pension / OTP',
  'pay.pensionOtpHelp': 'Obligatorisk tjänstepension (OTP) är lagstadgat sparande till de anställdas pension — minst 2 % av lönen. Här registrerar och följer du upp inbetalningarna till pensionsleverantören från godkända lönekörningar.',
  'pay.pensionPayments': 'Pensionsinbetalningar',
  'pay.pensionPaymentsSub': 'Registrera och håll koll på OTP-betalningarna från godkända lönekörningar.',
  'pay.newPensionPayment': 'Ny pensionsinbetalning',
  'pay.calculatedOtp': 'Beräknad OTP',
  'pay.calculatedOtpHelp': 'Total beräknad obligatorisk tjänstepension för året, från godkända lönekörningar.',
  'pay.open2': 'Öppet',
  'pay.unpaid': 'Obetalt',
  'pay.unpaidOtpHelp': 'OTP som har beräknats men ännu inte betalats till pensionsleverantören.',
  'pay.otp': 'OTP',
  'pay.paidOtpHelp': 'OTP som redan har betalats in till pensionsleverantören.',
  'pay.otpPaidWithDifference': 'Betalt {{paid}} · differens {{difference}}',
  'pay.noOtpBasis': 'Inget OTP-underlag ännu',
  'pay.payPeriod': 'Löneperiod',
  'pay.pensionPayment': 'Pensionsinbetalning',
  'pay.otpRefPh': 'T.ex. OTP-06',
  'pay.holidayPayList': 'Semesterersättningslista',
  'pay.holidayPayListSub': 'Intjänad och utbetald semesterersättning från godkända lönekörningar.',
  'pay.holidayPayBasis': 'Semesterersättningsunderlag',
  'pay.earned': 'Intjänad',
  'pay.noHolidayPay': 'Ingen semesterersättning ännu',
  'pay.paymentDate': 'Utbetalningsdatum',
  'pay.holidayPayBasisHelp': 'Summan av lön som ger rätt till semesterersättning. Semesterersättningen beräknas som en procentsats av detta underlag.',
  'pay.holidayPayEarnedHelp': 'Semesterersättning intjänad hittills — normalt 10,2 % av underlaget (12 % vid fem veckors semester). Betalas ut året efter intjänandet.',
  'pay.holidayPayPaidHelp': 'Semesterersättning som redan har betalats ut till anställda i år.',
  'pay.voucherShort': 'Verifikation:',
  'pay.paidOutShort': 'Utbet.:',
  'pay.earnedShort': 'Intjänat:',
  'pay.paidShort': 'Utbetalt:',
  'pay.salaryLine': 'Lönerad',
  'pay.newLine': 'Skapa ny rad',
  'pay.taxResidentCountry': 'Skattemässigt bosatt i land',
  'pay.earningCountry': 'Intjänandeland',
  'pay.earningRelation': 'Intjänandeförhållande',
  'pay.noPrefill': 'Låt inte belopp/antal vara förifyllt för den här raden i nya löneutbetalningar',
  'pay.holidayPayPayout': 'Utbetalning av semesterersättning',
  'pay.addHolidayPay': 'Lägg till semesterersättning',
  'pay.earnedEarlier': 'Intjänat tidigare',
  'pay.earnedThisYear': 'Intjänat i år',
  'pay.pensionContribution': 'Tillskott/premie till pension',
  'pay.registerPensionContribution': 'Registrera tillskott/premie till pension',
  'pay.fetchNavRefunds': 'Hämta återbetalningar från NAV',
  'pay.fetchNavRefundsSub': 'Hämta återbetalningar som ska tas med i löneutbetalningen.',
  'pay.emailPayslips': 'Skicka lönebesked via e-post',
  'pay.sendPayslips': 'Skicka lönebesked',
  'pay.sendLater': 'Skicka senare',
  'pay.sendPayslip': 'Skicka lönebesked',
  'pay.sendAllPayslips': 'Skicka till alla',
  'pay.sending': 'Skickar ...',
  'pay.payslipSendFailed': 'Kunde inte skicka lönebesked.',
  'pay.payslipSendUnavailable': 'Utskick av lönebesked är inte kopplat till backend.',
  'pay.downloadPayslip': 'Ladda ner lönebesked',
  'pay.downloadAllPdf': 'Ladda ner alla (PDF)',
  'pay.downloading': 'Laddar ner ...',
  'pay.sendTime': 'Tidpunkt för utskick',
  'pay.payslipsAfterPosting': 'Lönebesked kan laddas ner när löneutbetalningen har bokförts.',
  'pay.noPayslipsShort': 'Inga lönebesked',
  'pay.paymentInfo': 'Information om utbetalning',
  'pay.copyToClipboard': 'Kopiera till urklipp',
  'pay.downloadExcel': 'Ladda ner Excel',
  'pay.registerPayment': 'Registrera utbetalning',
  'pay.paymentsFromOperating': 'Utbetalningar från driftskonto:',
  'pay.toBankAccount': 'Till bankkonto',
  'pay.paidOutDate': 'Utbetalningsdatum',
  'pay.bankTip': 'Tips! Glöm inte att göra själva utbetalningen av skatteavdrag och lön i internetbanken.',
  'pay.linkVoucher': 'Koppla verifikation',
  'pay.noInboxVouchers': 'Inga verifikationer i inkorgen',
  'pay.newSalaryLine': 'Ny lönerad',
  'pay.paidOutVerb': 'Betalas ut',
  'pay.agaShort2': 'Arb.avg.',
  'pay.holiday': 'Semester',
  'pay.noExtraLines': 'Inga extra lönerader har lagts till ännu.',
  'pay.showEmployeePage': 'Visa anställdsida',
  'pay.addSalaryLine': 'Lägg till lönerad',
  'pay.noEmployeesInRun': 'Inga anställda i löneutbetalningen',
  'pay.holidayPensionDeductions': 'Semesterersättning, pension och avdrag',
  'pay.pensionContributionOrPremium': 'Tillskott eller premie till pension',
  'pay.summary': 'Sammanfattning',
  'pay.payrollRun': 'Löneutbetalning',
  'pay.agaRate': 'Arb.avgift (14,1 %)',
  'pay.posting': 'Bokföring',
  'pay.writeComment': 'Skriv en kommentar',
  'pay.seePayslips': 'Se lönebesked',
  'pay.nextStep': 'Nästa steg',
  'pay.sendAmeldingToAltinn': 'Skicka A-melding till Altinn',
  'pay.deletePayrollRun': 'Ta bort löneutbetalning',
  'pay.manualSubmission': 'Manuell inlämning',
  'pay.sendAmelding': 'Skicka A-melding',
  'pay.altinnConfirmation': 'Bekräftelse från Altinn',
  'pay.altinnConfirmationHelp': 'När A-meldingen är skickad väntar du på bekräftelse innan lönebeskeden skapas.',
  'pay.createPayslips': 'Skapa lönebesked',
  'pay.editPayrollRun': 'Ändra löneutbetalning',
  'pay.registerPaymentToEmployees': 'Registrera betalning till anställda och skatt',
  'pay.cancelPosting': 'Makulera bokföringen',
  'pay.cancelPostingConfirmTitle': 'Makulera bokföringen?',
  'pay.cancelPostingConfirmMessage': 'Detta återställer löneutbetalningen till utkast. Registrerade utbetalningar och själva bokföringen makuleras och tas bort från aktiva redovisningssiffror. Du måste kontrollera och godkänna lönen på nytt.',
  'pay.cancelPostingConfirmAction': 'Makulera bokföringen',
  'pay.keepPosting': 'Behåll bokföringen',
  'pay.seeAccountingVoucher': 'Se bokföringsverifikation',
  'pay.registerPayments': 'Registrera utbetalningar',
  'pay.payrollDone': 'Lönen är körd och bokförd!',
  'pay.payrollDoneSub': 'Löneutbetalningen är inskickad, bokförd och registrerad som utbetald.',
  'pay.allPayrollRuns': 'Alla löneutbetalningar',
  'pay.noEntries': 'Inga konteringar',
  'pay.calculatedWithholding': 'Beräknat skatteavdrag',
  'pay.toPayOut': 'Att betala ut',
  'pay.activePayrollRuns': 'Aktiva löneutbetalningar',
  'pay.runsCount': '{{count}} körningar',
  'pay.employeesInActiveRuns': '{{count}} anställda i aktiva körningar',
  'pay.createNewRunHint': 'Skapa en ny löneutbetalning för att hämta in anställda, fasta lönerader och godkända resor.',
  'pay.activePayrollRunsHelp': 'En löneutbetalning beräknar lön, skatteavdrag, semesterersättning och arbetsgivaravgift för en period. Aktiva körningar är under arbete.',
  'pay.newPayrollRun': 'Ny löneutbetalning',
  'pay.noActiveRuns': 'Inga aktiva löneutbetalningar',
  'pay.earlierPayrollRuns': 'Tidigare löneutbetalningar',
  'pay.earlierPayrollRunsHelp': 'Lönekörningar där utbetalningen är registrerad. Du kan öppna dem för detaljer, lönebesked och bokföringsverifikationer.',
  'pay.orderNumberDate': 'Senaste utbetalning först',
  'pay.travelAndExpenses': 'Resor och utlägg',
  'pay.createPayrollRun': 'Skapa ny löneutbetalning',
  'pay.payrollRunDate': 'Datum för löneutbetalning',
  'pay.payPeriodMonthHelp': 'Månaden lönen gäller för. Utbetalningsdatumet kan vara ett eget datum.',
  'pay.paymentDateHelp': 'Datumet då pengarna faktiskt betalas ut. Detta ändrar inte löneperioden.',
  'pay.paymentDatePeriodWarning': 'Utbetalningsdatumet ligger utanför normal månad för löneperioden. Kontrollera att löneperioden och datumet är rätt.',
  'pay.includeFixedLines': 'Ta med fasta lönerader',
  'pay.includeExpenseLines': 'Ta med rader för utlägg',
  'pay.readyExpenseLineCount': '{count} rader klara för utbetalning',
  'pay.payPeriodLength': 'Löneperiod (intjänandelängd)',
  'pay.ordinaryWithholding': 'Vanligt skatteavdrag',
  'pay.useTaxCard': 'Använd skattekort när det finns',
  'pay.optionalComment': 'Valfri kommentar',
  'pay.salaryTypesAndDeductions': 'Lönearter och avdrag',
  'pay.salaryTypesHelp': 'Lönearter styr hur en lönerad hanteras för arbetsgivaravgift, skatteavdrag, semesterersättning och pension.',
  'pay.newSalaryType': 'Ny löneart',
  'pay.agaLiableHelp': 'Om lönearten ingår i underlaget för arbetsgivaravgift. Ikryssad = avgiftspliktig.',
  'pay.withholdingLiableHelp': 'Om lönearten är avdragspliktig — alltså om preliminärskatt ska dras av beloppet.',
  'pay.holidayPayLiableHelp': 'Om lönearten ger semesterersättningsunderlag — alltså om semesterersättning tjänas in på beloppet.',
  'pay.pension': 'Pension',
  'pay.pensionLiableHelp': 'Om lönearten ingår i underlaget för obligatorisk tjänstepension (OTP).',
  'pay.rules': 'Regler',
  'pay.noLiabilityRules': 'Inga avgifts- eller avdragspliktiga regler',
  'pay.noEffect': 'Ingen påverkan',
  'pay.bonusExamplePh': 'T.ex. Bonus utan semesterersättning',
  'pay.benefitInKind': 'Naturaförmån',
  'pay.deduction': 'Avdrag',
  'pay.taxFreeAllowance': 'Skattefri ersättning',
  'pay.overrideNote': 'Ändringar sparas som företagets åsidosättning av standardtypen.',
  'pay.ratePerMonth': 'Sats (per månad)',
  'pay.calculated': 'Beräknas',
  'pay.changeCountries': 'Ändra intjänandeland/bosatt i land',
  'pay.optionalCommentPh': 'Valfri kommentar ...',
  'pay.fixedSalaryLines': 'Fasta lönerader',
  'pay.fixedSalaryLinesSub': 'Lönerader som upprepas automatiskt vid varje lönekörning.',
  'pay.addFixedLine': 'Lägg till fast lönerad',
  'pay.noFixedLines': 'Inga fasta lönerader',
  'pay.payrollSettings': 'Löneinställningar',
  'pay.payrollSettingsSub': 'Standardval som används när Plumme bokför lön, arbetsgivaravgift, semesterersättning och pension.',
  'pay.contributionAndHoliday': 'Avgift och semesterersättning',
  'pay.agaZone': 'Zon för arbetsgivaravgift',
  'pay.holidayPayRate': 'Sats för semesterersättning',
  'pay.pensionOtpShort': 'Pension (OTP)',
  'pay.pensionProvider': 'Pensionsleverantör',
  'pay.providerOrgNo': 'Org.nr leverantör',
  'pay.otpRate': 'OTP-sats',
  'pay.accountsAndReporting': 'Konton och rapportering',
  'pay.payrollAccount': 'Lönekonto (bank)',
  'pay.withholdingAccount': 'Skatteavdragskonto',
  'pay.firstPayrollYear': 'Första år för lönebokföring',
  'pay.entityNumber': 'Arbetsställenummer',
  'pay.holidayPayPercent': 'Procent semesterersättning',
  'pay.holidayPayPercentHelp': 'Den sats som semesterersättning tjänas in med. 10,2 % är lagens minimum; 12 % gäller vid avtal om fem veckors semester.',
  'pay.holidayPayMonth': 'Månad för semesterersättning',
  'pay.month.january': 'Januari',
  'pay.month.february': 'Februari',
  'pay.month.march': 'Mars',
  'pay.month.april': 'April',
  'pay.month.june': 'Juni',
  'pay.month.july': 'Juli',
  'pay.month.august': 'Augusti',
  'pay.month.september': 'September',
  'pay.month.october': 'Oktober',
  'pay.month.november': 'November',
  'pay.month.december': 'December',
  'pay.shift.none': 'Inget skift',
  'pay.shift.shift': 'Skift',
  'pay.shift.rota': 'Turlista',
  'pay.shift.continuous': 'Kontinuerligt skiftarbete',
  'pay.ordinary': 'Vanlig',
  'pay.maritime': 'Sjöfart',
  'pay.freelancer': 'Frilansare',
  'pay.pensionOrOtherBenefit': 'Pension eller annan ersättning',
  'pay.municipalityAndNumber': 'Kommun och kommunnummer',
  'pay.pickMunicipality': 'Välj kommun',
  'pay.calculationCode': 'Beräkningskod',
  'pay.generalIndustries': 'Allmänna näringar',
  'pay.agricultureForestry': 'Jordbruk och skogsbruk',
  'pay.fishing': 'Fiske och fångst',
  'pay.pensionProviderOtp': 'Pensionsleverantör (OTP)',
  'pay.withholdingAccounts': 'Avdragskonton',
  'pay.payoutAccount': 'Konto för löneutbetalning',
  'pay.amelding': 'A-melding',
  'pay.everyMonth': 'Varje månad',
  'pay.everyPayrollRun': 'Vid varje lönekörning',
  'pay.taxCardChangeAlert': 'Avisering vid ändring av skattekort',
  'pay.emailPh': 'namn@foretag.no',
  'pay.sms': 'SMS',
  'pay.savingsAccount': 'Sparkonto',
  'pay.withholdingMode.fiftyPercent': '50 % skatteavdrag',
  'pay.withholdingMode.standardHint': 'Använder giltigt skattekort registrerat på den anställda. Saknas det dras 50 %.',
  'pay.withholdingMode.taxCardHint': 'Skattekort hämtas inte automatiskt från Skatteetaten ännu. Plumme använder skattekortet som är registrerat på den anställda, och drar 50 % när giltigt skattekort saknas.',
  'pay.withholdingMode.fiftyPercentHint': 'Drar 50 % av avdragsunderlaget för alla anställda i den här lönekörningen, oavsett skattekort.',
  'pay.holidayPayPrevious.hint': 'Intjänat i fjol är beräknat från godkända lönekörningar i fjol, minus det som redan har betalats ut. Semesterersättning intjänad innan du började använda Plumme ingår inte – justera beloppet med pennan.',
  'pay.deductionAccount.label': 'Konto som avdraget krediteras',
  'pay.deductionAccount.hint': 'Avdrag som betalas vidare till andra är skulder. Välj 2610 för utmätning. Plumme rapporterar inte utmätning i a-meldingen – avdraget måste betalas vidare separat.',
  'pay.deductionAccount.canteen': '5919 Avdrag för personalmatsal anställda',
  'pay.deductionAccount.garnishment': '2610 Utmätning',
  'pay.deductionAccount.unionDues': '2650 Avdragen fackföreningsavgift',
  'pay.deductionAccount.other': '2690 Övriga avdrag',
  'pay.taxRuleUnsupportedError': 'Plumme stöder inte {rule} ännu – kör lönen för {employee} utanför Plumme.',
  'err.payroll.unsupportedTaxRule': 'En anställd i lönekörningen har en skatte- och avgiftsregel som Plumme inte stöder ännu. Kör lönen för den här anställda utanför Plumme.',
  'pay.taxRules.svalbard': 'Svalbard',
  'pay.taxRules.janMayen': 'Jan Mayen och biländerna',
  'pay.taxRules.seafarerDeduction': 'särskilt avdrag för sjöfolk',
  'pay.taxRules.charity': 'välgörande eller allmännyttig organisation',
  'pay.taxRules.netPay': 'nettolön',
  'pay.taxRules.netPaySeafarer': 'nettolön för sjöfolk',
  'pay.taxRules.pensionSourceTax': 'källskatt på pensioner',
  'pay.taxRules.nanny': 'dagmamma i barnets hem',
  'pay.taxRules.homeWork': 'lönearbete i hemmet',
  'pay.taxRules.taxFreeOrganization': 'skattefri organisation',
  'pay.pensionAllocation.explain': 'Premien ersätter beräknad OTP för de anställda du väljer. Väljer du flera fördelas beloppet efter deras OTP-underlag.',
  'pay.pensionAllocation.employees': 'Anställda som premien gäller',
  'pay.pensionAllocation.amountRequired': 'Ange ett belopp större än 0.',
  'pay.pensionAllocation.noEmployees': 'Välj minst en anställd som premien gäller.',
  'pay.pensionAllocation.noBasis': 'De valda anställda har inget OTP-underlag i den här lönekörningen. Välj en anställd, eller lägg in lön först.',
  'pay.pensionAllocation.noLines': 'Lönekörningen har inga anställda att koppla pensionspremien till.',
  'pay.pensionAllocation.saveFailed': 'Kunde inte registrera pensionspremien.',
  'pay.travelNotPayableError': 'Dessa reseräkningar eller utlägg kan inte längre betalas ut i den här lönekörningen: {travels}. De har redan betalats ut i en annan körning eller är inte godkända. Ta bort dem från utkastet, eller återför körningen som betalade ut dem.',
  'err.payroll.travelNotPayable': 'En reseräkning eller ett utlägg i lönekörningen har redan betalats ut i en annan körning, eller är inte längre godkänt. Ta bort raden från utkastet innan du godkänner.',
  'pay.noCalculationBasis': 'Inga beräkningsunderlag',
  'pay.payTypeGroup.common': 'Vanliga',
  'pay.payTypeGroup.custom': 'Egna lönearter',
  'pay.payTypeGroup.other': 'Andra lönearter',
  'pay.payTypeGroup.benefitInKind': 'Naturaförmåner',
  'pay.payTypeGroup.deduction': 'Avdrag',
  'pay.payTypeGroup.taxFreeAllowance': 'Skattefria ersättningar',
  'pay.inactive': 'inaktiv',
  'pay.selectSalaryType': 'Välj löneart',
  'pay.searchSalaryTypeOrRule': 'Sök efter löneart eller regel',
  'pay.showMoreSalaryTypes': 'Visa fler lönearter',
  'pay.calculationRules': 'Beräkningsregler',
  'pay.agaAndTaxTab': 'Arbetsgivaravgift och skatt',
  'pay.pensionOtpTab': 'Pension/OTP',
  'pay.zone': 'Zon',
  'pay.status.paid': 'Betald',
  'pay.status.unpaid': 'Inte betald',
  'pay.status.approved': 'Godkänd',
  'pay.status.annulled': 'Makulerad',
  'pay.status.draft': 'Utkast',
  'pay.status.partiallyPaid': 'Delvis betald',
  'pay.select': 'Välj',
  'pay.search': 'Sök',
  'pay.noDataYet': 'Inga data ännu',
  'pay.noDataYetBody': 'När det finns registreringar visas de här.',
  'pay.notSet': 'Inte angivet',
  'pay.thisIsADeduction': 'Detta är ett avdrag',
  'pay.fixedLineHint.payout': 'Raden betalas ut till den anställda',
  'pay.fixedLineHint.taxable': 'Skattepliktig - ingår i skatteavdraget',
  'pay.fixedLineHint.employerContribution': 'Ingår i underlaget för arbetsgivaravgift',
  'pay.fixedLineHint.holidayPay': 'Ingår i underlaget för semesterersättning',
  'pay.fixedLineHint.pension': 'Ingår i underlaget för pension (OTP)',
  'pay.fixedLineHint.deduction': 'Negativt belopp - dras från utbetalningen',
  'pay.amountMustBePositive': 'Beloppet måste vara större än 0.',
  'pay.amountExceedsOpenTerm': 'Beloppet får inte vara högre än det som är öppet på terminen.',
  'pay.allocationMustMatchAmount': 'Fördelningen måste vara lika med beloppet och får inte överstiga öppna belopp.',
  'pay.paymentUpdated': 'Betalning uppdaterad.',
  'pay.paymentRegistered': 'Betalning registrerad.',
  'pay.savePaymentFailed': 'Kunde inte spara betalning.',
  'pay.paymentAnnulled': 'Betalning makulerad.',
  'pay.annulPaymentFailed': 'Kunde inte makulera betalning.',
  'pay.allPensionPaymentsRegistered': 'Alla pensionsinbetalningar är registrerade.',
  'pay.noOtpToRegisterYet': 'Ingen beräknad OTP att registrera ännu.',
  'pay.missingPayrollRunForOtp': 'Lönekörning saknas för OTP-betalningen.',
  'pay.pensionPaymentRegistered': 'Pensionsbetalning registrerad.',
  'pay.registerPensionPaymentFailed': 'Kunde inte registrera pensionsbetalning.',
  'pay.explainRuleOverrideRequired': 'Motivera varför beräkningsreglerna åsidosätts.',
  'pay.navRefundsFetched': 'NAV-ersättningar hämtade.',
  'pay.navRefundsFetchFailed': 'Kunde inte hämta ersättningar från NAV.',
  'pay.payslipDownloaded': 'Lönebesked nedladdat.',
  'pay.payslipDownloadFailed': 'Kunde inte ladda ner lönebesked.',
  'pay.payslipsDownloaded': 'Lönebesked nedladdade.',
  'pay.payslipsDownloadFailed': 'Kunde inte ladda ner lönebesked.',
  'pay.paymentInfoCopied': 'Utbetalningsinformation kopierad.',
  'pay.paymentFileDownloaded': 'Utbetalningsfil nedladdad.',
  'pay.linkInboxDocumentFailed': 'Kunde inte koppla verifikation från inkorgen.',
  'pay.payrollRunCreated': 'Löneutbetalning skapad.',
  'pay.payrollRunCreateFailed': 'Kunde inte skapa löneutbetalning.',
  'pay.payrollRunUpdateFailed': 'Kunde inte uppdatera löneutbetalningen.',
  'pay.deletedPayrollRunRemoved': 'Borttagen löneutbetalning har tagits bort.',
  'pay.removePayrollRunFailed': 'Kunde inte ta bort löneutbetalningen.',
  'pay.commentSaved': 'Kommentar sparad.',
  'pay.salaryLineAdded': 'Lönerad tillagd.',
  'pay.voucherLinkedToPayrollRun': 'Verifikation kopplad till löneutbetalningen.',
});
